import React from "react";
import HeroSection from "./HeroSection";
import './Home.css'
const Home = () => {
  return (
    <div>
      <HeroSection />
    </div>
  );
};

export default Home;
